import * as React from 'react'
import { memo } from 'react'
const SvgCar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 14"
  >
    <path d="M1.231 12v1.5a.48.48 0 0 1-.144.356.48.48 0 0 1-.356.144H.5a.48.48 0 0 1-.356-.144A.48.48 0 0 1 0 13.5V6.154L1.984.5a.65.65 0 0 1 .282-.369A.86.86 0 0 1 2.731 0h10.615a.68.68 0 0 1 .412.137.7.7 0 0 1 .257.363L16 6.154V13.5a.48.48 0 0 1-.144.356.48.48 0 0 1-.356.144h-.231a.48.48 0 0 1-.356-.144.48.48 0 0 1-.144-.356V12Zm.185-6.846h13.169L13.111 1H2.889Zm2.012 4.539a1.07 1.07 0 0 0 .789-.327 1.09 1.09 0 0 0 .322-.793 1.07 1.07 0 0 0-.327-.789 1.09 1.09 0 0 0-.793-.322 1.07 1.07 0 0 0-.789.327 1.09 1.09 0 0 0-.322.793 1.07 1.07 0 0 0 .326.789 1.09 1.09 0 0 0 .794.321Zm9.154 0a1.07 1.07 0 0 0 .789-.327 1.09 1.09 0 0 0 .322-.793 1.07 1.07 0 0 0-.326-.789 1.09 1.09 0 0 0-.793-.322 1.07 1.07 0 0 0-.789.327 1.09 1.09 0 0 0-.322.793 1.07 1.07 0 0 0 .327.789 1.09 1.09 0 0 0 .791.321Z" />
  </svg>
)
const Memo = memo(SvgCar)
export default Memo
